const hours = getSupportHoursForToday();
const openRange = getOpenDaysRange();

if (!hours) {
    // Zavřeno -> žádné hodiny nejsou definované
    $('.customContactBox').addClass('isOffline');
    $('.customContactBox .openHours').text(openRange);
    $('.customFloatingContact').addClass('CloseHour')
   
}
else if (isSupportOnline(hours)) {
    // Otevřeno právě teď
    $('.customContactBox').addClass('isOnline');
    $('.customContactBox .top .right .onlineOffline').text(translation('nynijsmeOnline'))
    $('.customContactBox .openHours').text(openRange);
    $('.customFloatingContact').addClass('openHour')
}
else {
    // Dnes je otevřeno, ale teď mimo provozní dobu
    $('.customContactBox').addClass('isOffline');   
    $('.customContactBox .openHours').text(openRange);
    $('.customFloatingContact').addClass('CloseHour')
}


function fixedHolidays(year) {
    return [
        `${year}-01-01`,
        `${year}-05-01`,
        `${year}-05-08`,
        `${year}-07-05`,
        `${year}-07-06`,
        `${year}-09-28`,
        `${year}-10-28`,
        `${year}-11-17`,
        `${year}-12-24`,
        `${year}-12-25`,
        `${year}-12-26`,
    ];
}

function getEasterDates(year) {
    let f = Math.floor,
        a = year % 19,
        b = f(year / 100),
        c = year % 100,
        d = f(b / 4),
        e = b % 4,
        g = f((8 * b + 13) / 25),
        h = (19 * a + b - d - g + 15) % 30,
        i = f(c / 4),
        k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = f((a + 11 * h + 22 * l) / 451),
        month = f((h + l - 7 * m + 114) / 31),
        day = ((h + l - 7 * m + 114) % 31) + 1;
    const sunday = new Date(year, month - 1, day);
    const monday = new Date(year, month - 1, day + 1);
    return [
        sunday.toISOString().slice(0, 10),
        monday.toISOString().slice(0, 10),
    ];
}

function toMinutes(time) {
    if (!time) return null;
    const [h, m] = time.split(':');
    return parseInt(h) * 60 + parseInt(m);
}

function getSupportHoursForToday() {
    const now = new Date();
    const year = now.getFullYear();
    const today = now.toISOString().slice(0, 10);
    const weekday = now.getDay() === 0 ? 7 : now.getDay();
    if (manualExtendedHours[today]) {
        return manualExtendedHours[today];
    }
    if (manualClosedDays[today]) {
        return null;
    }
    const holidays = [...fixedHolidays(year), ...getEasterDates(year)];
    if (holidays.includes(today)) {
        return null;
    }
    return supportHours[weekday] || null;
}

function isSupportOnline(hours) {
    if (!hours) return false;

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const open = toMinutes(hours.open);
    const close = toMinutes(hours.close);

    return currentMinutes >= open && currentMinutes < close;
}


function isHoliday(date) {
    const year = date.getFullYear();
    const iso = date.toISOString().slice(0, 10);
    const holidays = [...fixedHolidays(year), ...getEasterDates(year)];
    return holidays.includes(iso);
}

function isWorkingDay(date) {
    const day = date.getDay(); // 0 = ne
    return day !== 0 && day !== 6 && !isHoliday(date);
}

function afterDeliveryCutoff(now) {
    const [h, m] = deliveryHours.split(':').map(Number);
    return now.getHours() * 60 + now.getMinutes() >= (h * 60 + m);
}

function addWorkingHours(startDate, hoursToAdd) {
    const date = new Date(startDate);
    let remaining = hoursToAdd;

    while (remaining > 0) {
        date.setHours(date.getHours() + 1);

        if (isWorkingDay(date)) {
            remaining--;
        }
    }

    return date;
}

function formatDeliveryDate(date) {
    const today = new Date();
    today.setHours(0,0,0,0);

    const target = new Date(date);
    target.setHours(0,0,0,0);

    const diffDays = Math.round((target - today) / (1000 * 60 * 60 * 24));

    const day = date.getDate();
    const month = date.getMonth() + 1;

    if (diffDays === 1) return `zítra ${day}. ${month}. u vás`;
    if (diffDays === 2) return `pozítří ${day}. ${month}. u vás`;

    return `${day}. ${month}. u vás`;
}

function getDeliveryDateByAvailability(availabilityText) {
    const hours = deliveryMap[availabilityText];
    if (!hours) return null;

    const now = new Date();

    // po cut-off → začínáme až další pracovní den
    if (afterDeliveryCutoff(now)) {
        do {
            now.setDate(now.getDate() + 1);
        } while (!isWorkingDay(now));
        now.setHours(9, 0, 0, 0); // start dne
    }

    return addWorkingHours(now, hours);
}

function getOpenDaysRange() {
const dayShort = [null, translation('po'), translation('ut'), translation('st'), translation('ct'), translation('pa'), translation('so'), translation('ne')];
   // const dayShort = [null, "Po", "Út", "St", "Čt", "Pá", "So", "Ne"];

    let firstDay = null;
    let lastDay = null;
    let hours = null;

    for (let day = 1; day <= 7; day++) {

        if (supportHours[day]) {

            if (!firstDay) {
                firstDay = day;
                hours = supportHours[day];
            }

            lastDay = day;
        }
    }

    if (!firstDay) return "";

    if (firstDay === lastDay) {
        return `${dayShort[firstDay]}: ${hours.open} - ${hours.close}`;
    }

    return `${dayShort[firstDay]} - ${dayShort[lastDay]}: ${hours.open} - ${hours.close}`;
}